module.exports = __webpack_public_path__ + "static/matthew-e7070153910817c5ee680ea1193584c2.png";